<template>
<div class="row">
  <template v-for="product in products">
    <div class="col-md-3 col-sm-4 col-xs-6 mb-3" v-if="product.category_id == category || category == 0" :key="product.id">
      <div class="product card">
        <div class="card-img">
          <a :href="'/'+$t('routes.product')+'/'+product.product.nice_url">
            <img :src="product.product.thumb" alt="">
          </a>
          <div v-if="product.product.is_discounted" class="card-tag card-tag-discount">- {{ product.product.discount }} %</div>
          <div v-else-if="product.product.is_new" class="card-tag card-tag-new">{{ $t('general.singleProduct.new')}}</div>
          <div class="quarter-circle" @click="favoritesProductEdit(product.product.id, product.category_id, product.id)">
            <i class="icon-edit"></i>
          </div>
        </div>
        <div class="card-body">
          {{ product.product.name }}
        </div>
        <div class="card-footer">
          {{ $t('cart.price')}}:
          <span v-if="product.product.is_discounted" class="text-line-through">{{ product.product.brutto_price | monetary }} €</span>
          <span class="float-right">{{ product.product.price | monetary }} €</span>
        </div>
      </div>
    </div>
  </template>
</div>
</template>

<script>
import Request from '@Core/xhr'

export default {
  props: {
    category: {
      required: true,
      default: 0
    }
  },

  data () {
    return {
      products: []
    }
  },

  created () {
    window.App.dispatcher.listen('favorites.loaded', response => {
      this.products = response.result
    })
    
    new Request().get('/favorites/get').then((response) => {
        this.products = response.result;
    })
  },

  methods: {
    favoritesProductEdit (id, category, favorite) {
      window.App.dispatcher.fire('favorites-product-edit.open', { pid: id, cid: category, fid: favorite })
    }
  },

  filters: {
    monetary (value) {
      return parseFloat(value).toFixed(2).replace('.', ',')
    }
  }
}
</script>
